import React, { useState } from "react";

function TodoList() {
  const [tasks, setTasks] = useState([
    "Review Customers reports",
    "Give Lily Admin rights",
    "Refund Customer 4453",
  ]);
  const [task, setTask] = useState("");
  const [taskLimit, setTaskLimit] = useState(false);

  const addTasks = () => {
    if (task !== "" && tasks.length < 5) {
      setTaskLimit(false);
      setTasks([...tasks, task]);
      setTask("");
      console.log(tasks);
    }

    tasks.length == 5 && setTaskLimit(true);
  };

  const deleteTasks = (index) => {
    const updatedList = [...tasks];
    console.log("Automatic...");
    updatedList.splice(index, 1);
    setTasks(updatedList);
  };
  return (
    <div className="px-3 flex flex-col items-center">
      <div className="w-full">
        <input
          className="border border-gray-300 p-2 w-full focus:outline-none focus:ring-1 focus:ring-orange-300 rounded"
          type="text"
          value={task}
          onChange={(e) => {
            setTask(e.target.value);
          }}
          placeholder="Ex: Review today's report"
        />
        <button
          onClick={addTasks}
          disabled={!task.length}
          className=" bg-orange-500 text-white p-2 my-3 rounded-md font-bold hover:bg-orange-600"
        >
          Add Tasks
        </button>
      </div>
      <div className=" w-full">
        {tasks?.length > 0 ? (
          <ul>
            {tasks.map((task, index) => (
              <div
                className=" flex border-b border-b-gray-300  py-2 pr-4 w-full mb-2"
                key={index}
              >
                <li className="self-center text-lg pr-10 mr-6 grow">{task}</li>
                <button
                  onClick={() => {
                    deleteTasks(index);
                  }}
                  className="max-h-[40px] bg-gray-400 text-white p-2 mx-1 rounded-md font-bold hover:bg-red-500"
                >
                  Delete
                </button>
              </div>
            ))}
          </ul>
        ) : (
          <div>
            <p>No Task Found</p>
          </div>
        )}

        {taskLimit && (
          <div>
            <p>Limit reached!</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default TodoList;
